import { get } from "lodash";
import moment from "moment";
import {
  all,
  call,
  cancelled,
  delay,
  fork,
  put,
  select,
  takeLatest
} from "redux-saga/effects";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";
import { GET_MEDICAL_BILL_DETAIL_SUCCESS } from "~/store/booking/bookingType";
import * as notiActions from "~/store/notifications/notificationsActions";
import { apiRequestHealthInsuranceCard } from "~/store/payment/paymentApi";
import * as types from "~/store/payment/paymentType";
import * as totalDataActions from "~/store/totalData/actions";
import { huyi } from "~/utils/clog";
import { REDIRECT_URL_AFTER_BOOKING } from "~/utils/constants";
import { getDataToReserve, routerByPartnerId } from "~/utils/func";
import { getBaseUrl } from "~/utils/getBaseUrl";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";

function* checkStatus() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const totalReducer = yield select(state => state.totalData);
    const transactionId = get(
      totalReducer,
      "paymentInformation.bookingInfo.transactionId"
    );

    if (transactionId) {
      const response = yield client.checkTransaction(
        {
          transactionId
        },
        { platform }
      );

      const { status } = response.data;

      switch (status) {
        case 1:
          console.log("tao don hang");
          break;
        case 2:
          console.log("thanh cong");
          openToast("Giao dịch thành công.");
          yield put({
            type: types.STOP_GET_STATUS_TRANSACTION
          });
          history.push("/");
          break;
        case 3:
          console.log("that bai");
          yield put({
            type: types.STOP_GET_STATUS_TRANSACTION
          });

          openToast("Giao dịch thất bại.", "error");
          history.push("/");

          break;
        default:
          yield put({
            type: types.STOP_GET_STATUS_TRANSACTION
          });
          openToast("default", "error");
          break;
      }
    }
  } catch (error) {
    yield put({
      type: types.STOP_GET_STATUS_TRANSACTION
    });
    openToast("Giao dịch error", "error");
  }
}

function* requestStatusTransaction({ status }) {
  if (status === "active") {
    yield put({
      type: types.ACTIVE_STATUS_TRANSACTION
    });
  }

  let loopStatus = yield select(state => state.payment.loopStatus);

  try {
    while (loopStatus) {
      yield call(checkStatus);
      yield delay(5000);
      loopStatus = yield select(state => state.payment.loopStatus);
    }
  } finally {
    if (yield cancelled()) {
      checkStatus.close();
      requestStatusTransaction.close();
    }
  }
}

function* watchRequestStatusTransaction() {
  yield takeLatest(types.GET_STATUS_TRANSACTION, requestStatusTransaction);
}

function* requestHealthInsuranceCard() {
  try {
    const baseUrl = yield select(state => getBaseUrl());
    const { info } = yield select(state => state.user);
    const { paymentID } = yield select(state => state.healthInsuranceCard);
    const response = yield call(
      apiRequestHealthInsuranceCard,
      baseUrl,
      info,
      paymentID
    );
    if (response.error_code) throw new Error("Server error");
    const { data } = response;
    yield put({
      type: types.REQUEST_HEALTH_INSURANCE_CARD_SUCCESS,
      data
    });
    yield put({ type: GET_MEDICAL_BILL_DETAIL_SUCCESS, data: data[0] });
    yield put(
      notiActions.getNotification({
        user_id: info.user_id,
        access_token: info.access_token
      })
    );
  } catch (error) {
    yield put({
      type: types.REQUEST_HEALTH_INSURANCE_CARD_FAIL,
      error
    });
  }
}

function* watchRequestHealthInsuranceCard() {
  yield takeLatest(
    types.REQUEST_HEALTH_INSURANCE_CARD,
    requestHealthInsuranceCard
  );
}

// GET ALL PAYMENTS
function* requestGetAllPaymentMethods({ payload }) {
  try {
    const totalData = yield select(state => state.totalData);
    const patient = yield select(state => state.patient);
    const token = yield select(state => state.user.info.token);

    const priceOfAddOn =
      totalData.addonServices?.reduce((init, { price }) => {
        return init + price;
      }, 0) || 0;

    const bookingInfos = get(totalData, "schedulesSelected", []);
    const booking = bookingInfos.length > 0 ? bookingInfos[0] : null;
    const price = get(booking, "service.price", 0);
    const groupId = totalData.cskhUserId ? 4 : 1;
    const partnerid =
      totalData.paymentInformation?.bookingInfo?.partnerId ||
      (yield select(state => state.totalData.partnerId));
    const treeId = get(totalData, "treeId", "");

    const globalReducer = yield select(state => state.global);
    const platformType = get(globalReducer, "device.type");
    // openToast("platformType :>> " + platformType);

    const platform = platformType === "desktop" ? "pc" : "web";
    // openToast("platform :>> " + platform);

    const obj = {
      bookingId: totalData.paymentInformation?.bookingInfo?.id,
      patientId: patient?.selectedPatientId,
      price: (payload || price) + priceOfAddOn,
      groupId,
      treeId,
      serviceId: booking.service?.id,
      subjectId: booking.subject?.id,
      roomId: booking.room?.id,
      doctorId: booking.doctor?.id,
      bookingDate: moment(booking?.date).toISOString(),
      addonServices: totalData.addonServices?.map(i => i.id) || []
    };

    const response = yield client.getAllPaymentMethod(obj, {
      partnerid: partnerid || AppId,
      appid: AppId,
      platform,
      treeId,
      token
    });
    const { data } = response;

    yield put({
      type: types.UMC_GET_ALL_PAYMENT_METHODS_SUCCESS,
      data
    });

    if (AppId === "momo") {
      // tìm hình thức là momo
      const momoMethod = data.find(item => item.methodId === "momo");

      // chọn hình thức thanh toán là momo
      yield put({
        type: types.SELECTED_PAYMENT_METHOD,
        method: momoMethod.paymentTypes[0],
        methodId: momoMethod.methodId
      });
    }
  } catch (error) {
    huyi({
      name: "client.getAllPaymentMethod",
      child: error,
      type: 0
    });
    yield put({
      type: types.UMC_GET_ALL_PAYMENT_METHODS_FAIL,
      error
    });
  }
}

function* watchRequestAllPaymentMethod() {
  yield takeLatest(
    types.UMC_GET_ALL_PAYMENT_METHODS,
    requestGetAllPaymentMethods
  );
}

// ALL PAYMENT FEE METHODS
function* requestGetAllFeePaymentMethods() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const fee = yield select(state => state.fee);
    const priceFeePayment = get(fee, "selectedFee.amount", 0);

    const partnerid = yield select(state => state.totalData.partnerId);
    const response = yield client.getAllPaymentMethod(
      { price: priceFeePayment, groupId: 2 },
      { partnerid: partnerid, appid: AppId, platform }
    );
    const { data } = response;
    yield put({
      type: types.UMC_GET_ALL_PAYMENT_METHODS_SUCCESS,
      data
    });
  } catch (error) {
    yield put({
      type: types.UMC_GET_ALL_PAYMENT_METHODS_FAIL,
      error
    });
  }
}

function* watchRequestAllFeePaymentMethod() {
  yield takeLatest(
    types.GET_ALL_PAYMENT_METHOD_FEE,
    requestGetAllFeePaymentMethods
  );
}

// GET ALL PAYMENTS multiple
function* getAllPaymentMultiBooking({ payload }) {
  try {
    const totalData = yield select(state => state.totalData);
    const patient = yield select(state => state.patient);
    const token = yield select(state => state.user.info.token);

    const priceOfAddOn =
      totalData.addonServices?.reduce((init, { price }) => {
        return init + price;
      }, 0) || 0;

    const bookingInfos = get(totalData, "schedulesSelected", []);
    const partnerid =
      totalData.paymentInformation?.bookingInfo?.partnerId ||
      (yield select(state => state.totalData.partnerId));
    const treeId = get(totalData, "treeId", "");

    const globalReducer = yield select(state => state.global);
    const platformType = get(globalReducer, "device.type");

    const platform = platformType === "desktop" ? "pc" : "web";

    const arrBooking = bookingInfos.map(booking => {
      const price = get(booking, "service.price", 0);
      const groupId = totalData.cskhUserId ? 4 : 1;

      return {
        bookingId: totalData.paymentInformation?.bookingInfo?.id,
        patientId: patient?.selectedPatientId,
        price: (payload || price) + priceOfAddOn,
        groupId,
        treeId,
        serviceId: booking.service?.id,
        subjectId: booking.subject?.id,
        roomId: booking.room?.id,
        doctorId: booking.doctor?.id,
        bookingDate: moment(booking?.date).toISOString(),
        addonServices: totalData.addonServices?.map(i => i.id) || []
      };
    });

    const response = yield client.getAllPaymentMultiBooking(
      {
        bookings: arrBooking
      },
      {
        partnerid: partnerid || AppId,
        appid: AppId,
        platform,
        treeId,
        token: token
      }
    );
    const { data } = response;

    yield put({
      type: types.UMC_GET_ALL_PAYMENT_METHODS_SUCCESS,
      data
    });

    if (AppId === "momo") {
      // tìm hình thức là momo
      const momoMethod = data.find(item => item.methodId === "momo");

      // chọn hình thức thanh toán là momo
      yield put({
        type: types.SELECTED_PAYMENT_METHOD,
        method: momoMethod.paymentTypes[0],
        methodId: momoMethod.methodId
      });
    }
  } catch (error) {
    huyi({
      name: "client.getAllPaymentMultiBooking",
      child: error,
      type: "error"
    });
  }
}

function* watchRequestAllPaymentMethodMuitple() {
  yield takeLatest(
    types.GET_ALL_PAYMEN_MULTI_BOOKING_METHODS,
    getAllPaymentMultiBooking
  );
}

// CHECK REQUIRE PAYMENT
function* requestCheckRequirePayment() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    const totalDataReducer = yield select(state => state.totalData);
    const globalReducer = yield select(state => state.global);
    const paymentMethodReducer = yield select(state => state.payment);
    const patientReducer = yield select(state => state.patient);
    const reExamReducer = yield select(state => state.followUpExam);

    const partnerId = get(totalDataReducer, "partnerId");

    const postData = getDataToReserve(
      totalDataReducer,
      globalReducer,
      paymentMethodReducer,
      patientReducer,
      reExamReducer
    );

    const price = get(totalDataReducer, "service.price", "0");

    postData.subTotal = price;
    postData.redirectUrl = REDIRECT_URL_AFTER_BOOKING;

    const response = yield client.isRequirePayment(postData, {
      partnerid: partnerId,
      appid: AppId,
      platform
    });
    const isRequirePayment = get(response, "data.isRequirePayment", true);
    if (isRequirePayment) {
      const route = routerByPartnerId("/hinh-thuc-thanh-toan", partnerId);
      history.push(route);
    } else {
      yield put(totalDataActions.reserveBooking());
    }
  } catch (error) {
    huyi({
      name: "client.isRequirePayment",
      child: error,
      type: 0
    });
  }
}

function* watcherRequestCheckRequirePayment() {
  yield takeLatest(types.CHECK_REQUIRE_PAYMENT, requestCheckRequirePayment);
}

export default function* root() {
  yield all([
    fork(watchRequestStatusTransaction),
    fork(watchRequestHealthInsuranceCard),
    fork(watchRequestAllPaymentMethod),
    fork(watchRequestAllPaymentMethodMuitple),
    fork(watchRequestAllFeePaymentMethod),
    fork(watcherRequestCheckRequirePayment)
  ]);
}
